import { Brand as ProtoBrand } from '@italist/grpc-proto/entities/brand_pb';
import { Brand } from '../../models/brand';
import { buildBrandURL } from './url';

export const decorateBrand = (protoBrand: ProtoBrand): Brand => {
  const brand = protoBrand.toObject();
  return {
    ...brand,
    url: buildBrandURL(brand),
  };
};
